var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoublePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22c3.32 0 5.98-2.68 5.98-6s-2.66-6-5.98-6c-3.32 0-6 2.68-6 6s2.68 6 6 6zm-16 0c3.32 0 5.98-2.68 5.98-6s-2.66-6-5.98-6c-3.32 0-6 2.68-6 6s2.68 6 6 6zm0 4c-4.66 0-14 2.34-14 7v5h28v-5c0-4.66-9.34-7-14-7zm16 0c-.58 0-1.24.04-1.94.1 2.32 1.68 3.94 3.94 3.94 6.9v5h12v-5c0-4.66-9.34-7-14-7z",
    fill: "url(#cxxmhrry6a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cxxmhrry6a",
    x1: 2.5,
    y1: 10,
    x2: 48.889,
    y2: 14.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6033"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublePerson);
export default __webpack_public_path__ + "static/media/double_person.6bcab2b8552a2aef85592cdee734f8a8.svg";
export { ForwardRef as ReactComponent };